const TAB_ID_KEY = 'irsNotificationTabId';
const LEADER_KEY = 'irsNotificationLeader';
const HEARTBEAT_INTERVAL = 4000;
const LEADER_TIMEOUT = 10000;

const getTabId = () => {
  let tabId = sessionStorage.getItem(TAB_ID_KEY);
  if (!tabId) {
    tabId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(TAB_ID_KEY, tabId);
  }
  return tabId;
};

const tabId = typeof window !== 'undefined' ? getTabId() : '';

const readLeader = () => {
  try {
    return JSON.parse(localStorage.getItem(LEADER_KEY) || 'null');
  } catch (error) {
    return null;
  }
};

const writeLeader = () => {
  localStorage.setItem(LEADER_KEY, JSON.stringify({
    tabId,
    timestamp: Date.now(),
  }));
};

const shouldClaimLeadership = () => {
  const leader = readLeader();
  return !leader || leader.tabId === tabId || Date.now() - Number(leader.timestamp || 0) > LEADER_TIMEOUT;
};

export const startNotificationCoordinator = () => {
  if (typeof window === 'undefined') return () => {};

  if (shouldClaimLeadership()) {
    writeLeader();
  }

  const heartbeat = window.setInterval(() => {
    if (shouldClaimLeadership()) {
      writeLeader();
    }
  }, HEARTBEAT_INTERVAL);

  const releaseLeadership = () => {
    const leader = readLeader();
    if (leader?.tabId === tabId) {
      localStorage.removeItem(LEADER_KEY);
    }
  };

  window.addEventListener('beforeunload', releaseLeadership);

  return () => {
    window.clearInterval(heartbeat);
    window.removeEventListener('beforeunload', releaseLeadership);
    releaseLeadership();
  };
};

export const isNotificationLeader = () => {
  const leader = readLeader();
  return leader?.tabId === tabId;
};

export const shouldShowDesktopNotification = () =>
  isNotificationLeader();
